import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { TopThemeBase } from '@/components/modules/pages/top/contents/TopTheme/TopThemeBase';
import { TopThemeSliderItem, TopThemeSlider, } from '@/components/modules/pages/top/slider/TopThemeSlider';
export const TopThemeForPro = (props) => {
    const { className = '', items: propsItems } = props;
    const { oneLineArray, twoLineArray } = useMemo(() => {
        const items = [...propsItems];
        if (items.length % 2 !== 0) {
            items.push(null);
        }
        return {
            oneLineArray: items.slice(0, items.length / 2),
            twoLineArray: items.slice(items.length / 2, items.length),
        };
    }, [propsItems]);
    return (_jsx(TopThemeBase, Object.assign({ className: className }, { children: _jsx("div", Object.assign({ className: clsx('w-full sm:w-[536px] md:w-[736px]', 'mt-[18px] md:mt-[34px] mx-auto', 'pl-4 sm:pr-4') }, { children: _jsx(TopThemeSlider, Object.assign({ hasArrow: false }, { children: [...Array(oneLineArray.length)].map((_, index) => {
                    var _a, _b;
                    const oneLineItem = (_a = oneLineArray === null || oneLineArray === void 0 ? void 0 : oneLineArray[index]) !== null && _a !== void 0 ? _a : null;
                    const twoLineItem = (_b = twoLineArray === null || twoLineArray === void 0 ? void 0 : twoLineArray[index]) !== null && _b !== void 0 ? _b : null;
                    return (_jsxs("div", Object.assign({ className: '!inline-flex flex-col gap-y-12 md:gap-y-32' }, { children: [oneLineItem && (_jsx(TopThemeSliderItem, { image: oneLineItem.iconImage, linkTo: oneLineItem.caseLinkTo, text: oneLineItem.label })), twoLineItem && (_jsx(TopThemeSliderItem, { image: twoLineItem.iconImage, linkTo: twoLineItem.caseLinkTo, text: twoLineItem.label }))] }), `TopThemeForPro_item_${index + 1}`));
                }) })) })) })));
};
